import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Institutional from '@/pages/Institutional';
import HowItWorks from '@/pages/HowItWorks';
import TermsAndConditions from '@/pages/TermsAndConditions';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import KickoffMeeting from '@/pages/KickoffMeeting';
import ActivationSession from '@/pages/ActivationSession';
import Portfolio from '@/pages/Portfolio';
import SolutionDetail from '@/pages/SolutionDetail';
import CustomSolutions from '@/pages/CustomSolutions';
import WhatsAppButton from '@/components/WhatsAppButton';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Institutional />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/solutions" element={<Portfolio />} />
          <Route path="/solutions/:solutionId" element={<SolutionDetail />} />
          <Route path="/custom-solutions" element={<CustomSolutions />} />
          <Route path="/portfolio" element={<Navigate to="/solutions" replace />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/kickoff-meeting/:orderId" element={<KickoffMeeting />} />
          <Route path="/activation-session/:orderId" element={<ActivationSession />} />
        </Routes>
        
        {/* WhatsApp Floating Button - appears on all pages */}
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
